/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback } from 'react';
import classnames from 'classnames';
import { Icon } from '@ihsm/ui-shared';
import { ViewOption } from 'shared/types/ViewOption';
import './ViewSelector.scss';

export interface Props {
  selectedValues: string[];
  options: ViewOption[];
  onChange(value: string[]): void;
}

export const ViewSelector: React.FC<Props> = ({
  selectedValues,
  options,
  onChange,
}: Props): JSX.Element => {
  const handleChange = useCallback(
    (optionValue, isActive) => {
      if (isActive) {
        if (selectedValues.length > 1) {
          onChange(selectedValues.filter((value) => value !== optionValue));
        }
      } else {
        onChange([...selectedValues, optionValue]);
      }
    },
    [onChange, selectedValues]
  );

  return (
    <div className="viewselector-wrapper">
      {options.map(({ value: optionValue, iconSrc }) => (
        <div
          data-testid="viewselector-option"
          key={optionValue}
          className={classnames(`option ${optionValue}`, {
            active: selectedValues.includes(optionValue),
          })}
          onClick={handleChange.bind(
            null,
            optionValue,
            selectedValues.includes(optionValue)
          )}
        >
          <Icon source={iconSrc} />
        </div>
      ))}
    </div>
  );
};
